// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","Obituary":"Obituary","header":"header","flowersLink":"flowersLink","columns":"columns","columnLeft":"columnLeft","columnRight":"columnRight","container":"container","teaserText":"teaserText","showMore":"showMore","readMoreButton":"readMoreButton","ObituaryRight":"ObituaryRight","column":"column","sourceGroup":"sourceGroup"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/Obituary/css/Obituary.styl
// module id = 1664
// module chunks = 0